import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert/Alert';
import React from 'react';
import { State } from './type';

const FailureSnackbar: React.FunctionComponent<{
  state: State;
  onClose: () => void;
  message: string;
}> = ({ state, onClose, message }) => {
  return (
    <Snackbar
      open={state === State.FAIL}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={onClose} severity="error" variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
};
export default FailureSnackbar;
